<template>
  <div class="transactionEditor">
    <!--Transaction Editor Modal-->
    <div class="modal fade" ref="modal">
      <div class="modal-dialog modal-dialog modal-dialog-centered">
        <div class="modal-content" :class="{'loading': progress}">
          <!--Title-->
          <div class="modal-header py-3">
            <h4 class="modal-title"><i class="fas fa-file-export mr-2"></i>{{ 'Yeni İmza Talebi'|trans }}</h4>
            <button type="button" class="close" data-dismiss="modal">×</button>
          </div>

          <div class="modal-body">
            <!--Select or Upload Document-->
            <div class="d-flex align-items-center justify-content-center" v-if="!checkDocument">
              <button type="button" @click="$refs.documentBrowser.open()" class="btn btn-secondary btn-labeled btn-labeled-left">
                <b><i class="fas fa-file-alt px-1"></i></b>{{ 'Belge Seç'|trans }}
              </button>
              <span class="px-4">{{ 'ya da'|trans }}</span>
              <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left"
                onclick="document.getElementById('fileTransaction').click()">
                <b><i class="fas fa-plus px-1"></i></b>{{ 'Belge Yükle'|trans }}
              </button>
              <input type="file" id="fileTransaction" class="d-none" name="file" @change="document.file = $event.target.files[0]">
            </div>
            <div v-else>
              <!--Document Details-->
              <div class="form-group row" v-if="document.document_id">
                <label for="name" class="col-sm-4 col-form-label">{{ 'Belge'|trans }}</label>
                <div class="col-sm-8"><input type="text" class="form-control" id="name" v-model="document.name" disabled></div>
              </div>
              <div class="form-group row" v-else>
                <label for="name" class="col-sm-4 col-form-label">{{ 'Yeni Belge Adı'|trans }}</label>
                <div class="col-sm-8"><input type="text" class="form-control" id="name" v-model="document.name" required></div>
              </div>

              <!--Selected or Added Users-->
              <fieldset class="users mt-3" >
                <legend>{{ 'Gönderilecek Kullanıcılar'|trans }}</legend>

                <div v-for="(user, index) in users">
                  <div class="form-group row mb-0 position-relative" :class="{'mt-3': index > 0}">
                    <label :for="'email' + index" class="col-sm-4 col-form-label">{{ 'Kullanıcı'|trans }}</label>
                    <div class="col-sm-8">
                      <input type="email" :id="'email' + index" class="form-control"
                        v-model="user.email" required
                        :readonly="user.user_id !== null"
                        :placeholder="'E-posta adresi girin.'|trans"
                      >
                    </div>
                    <a href="#!" tabindex="-1" @click="removeUser(user, index)" class="close-absolute"><i class="fas fa-times-circle"></i></a>
                  </div>

                  <div class="form-group row mt-2 mb-0">
                    <div class="col-sm-8 offset-sm-4">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :id="'dse' + index" v-model="user.dont_send_email"
                          v-bind:true-value="1"
                          v-bind:false-value="0">
                        <label class="custom-control-label" :for="'dse' + index">{{ 'E-posta gönderilmesin'|trans }}</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Select User or Set Email-->
                <div class="d-flex align-items-center justify-content-center pt-3">
                  <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left" @click="$refs.userBrowser.open()">
                    <b><i class="fas fa-user px-1"></i></b>{{ 'Kullanıcı Ekle'|trans }}
                  </button>
                  <span class="px-4">{{ 'ya da'|trans }}</span>
                  <button type="button" class="btn btn-secondary btn-labeled btn-labeled-left" @click="onSelectUser">
                    <b><i class="fas fa-envelope px-1"></i></b>{{ 'E-posta Ekle'|trans }}
                  </button>
                </div>
              </fieldset>
            </div>
          </div>

          <!--Action Button-->
          <div class="modal-footer align-items-center justify-content-center">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'İptal'|trans }}</button> -->
            <button :disabled="!checkAll" type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="submitForm">
              <b><i class="fas fa-file-signature px-1"></i></b>{{ 'Tamamla'|trans }}</button>
          </div>
        </div>
      </div>
    </div>

    <!--
      Document Browser Component
    -->
    <api-browser ref="documentBrowser" :api="apiDocuments" api-order-by="created_at,desc" size="modal-lg">
      <div slot="header" class="modal-header py-3">
        <h4 class="modal-title"><i class='fas fa-file-alt mr-2'></i> {{ 'Belge Seç'|trans }}</h4>
        <button type="button" class="close" @click="$refs.documentBrowser.close()">×</button>
      </div>

      <template slot="filters" slot-scope="props">
        <div class="input-group-prepend">
          <input type="text" class="form-control rounded-0" v-model="props.params.filters.name" :placeholder="'Belgelerde ara..'|trans">
        </div>
        <select class="custom-select rounded-0" v-model="props.params.orderBy">
          <option value="name,asc">{{ 'İsim'|trans }} A-Z</option>
          <option value="name,desc">{{ 'İsim'|trans }} Z-A</option>
          <option value="created_at,asc">{{ 'Oluşma Tarihi'|trans }} A-Z</option>
          <option value="created_at,desc">{{ 'Oluşma Tarihi'|trans }} Z-A</option>
          <option value="updated_at,asc">{{ 'Güncellenme Tarihi'|trans }} A-Z</option>
          <option value="updated_at,desc">{{ 'Güncellenme Tarihi'|trans }} Z-A</option>
        </select>
      </template>

      <table slot="items" slot-scope="props" class="table table-hover mb-0">
        <tbody>
          <tr class="pointer" v-for="item in props.items">
            <td @click="onSelectDocument(item)">{{ item.id }}</td>
            <td class="td-thumb">
              <a :href="item.media.full_url" data-fancybox="fileman-links" data-type="iframe">
                <img class="file-thumbnail" :src="item.media.thumb_url"/>
              </a>
            </td>
            <td @click="onSelectDocument(item)">{{ item.name }}</td>
            <td @click="onSelectDocument(item)">
              <i class="fal fa-file-check fa-fw text-success-400 mr-1" v-if="item.status === 'signed'"></i>
              <i class="fal fa-file-signature fa-fw text-info-400 mr-1" v-else-if="item.status === 'pending'"></i>
              <i class="fal fa-file-edit fa-fw text-orange-400 mr-1" v-else></i>
              {{ item.status_readable }}
            </td>
            <td @click="onSelectDocument(item)">{{ item.created_at|formatDate }}</td>
            <td @click="onSelectDocument(item)">{{ item.media.size|formatByte }}</td>
          </tr>
        </tbody>
      </table>
    </api-browser>

    <!--
      User Browser Component
    -->
    <api-browser ref="userBrowser" :api="apiUsers">
      <div slot="header" class="modal-header py-3">
        <h4 class="modal-title"><i class='fas fa-user mr-2'></i> {{ 'Kullanıcı Ekle'|trans }}</h4>
        <button type="button" class="close" @click="$refs.userBrowser.close()">×</button>
      </div>

      <template slot="filters" slot-scope="props">
        <div><input type="text" class="form-control rounded-0" v-model="props.params.filters.name" :placeholder="'Kullanıcı ara..'|trans"></div>
        <div><input type="text" class="form-control rounded-0" v-model="props.params.filters.email" :placeholder="'E-posta ara..'|trans"></div>
      </template>

      <table slot="items" slot-scope="props" class="table table-hover mb-0">
        <tbody>
          <tr class="pointer" v-for="item in props.items">
            <td @click="onSelectUser(item)">{{ item.name }}</td>
            <td @click="onSelectUser(item)">{{ item.email }}</td>
            <td @click="onSelectUser(item)">{{ item.created_at|formatDate }}</td>
          </tr>
        </tbody>
      </table>
    </api-browser>
  </div>
</template>

<script>
import ApiBrowser from "./ApiBrowser";

function initialState () {
  return {
    document: {
      document_id: null,
      file: null,
      name: null,
    },
    users: [],
    formData: new FormData(),
    regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    progress: false
  }
}

export default {
  props: ['apiCreate', 'apiDocuments', 'apiUsers'],
  components: {'api-browser': ApiBrowser},
  data() {
    return initialState()
  },
  filters: {
    formatByte: (val) => {
      return (val / (1024 * 1024)).toFixed(2) + ' MB';
    },
    formatDate(val) {
      return (new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }).format(new Date(Date.parse(val))));
    },
  },
  beforeCreate() {
    window.TransactionEditor = this;
  },
  mounted() {
    // Close Other Modal
    $(this.$refs.modal).on('hide.bs.modal', (e) => {
      Object.keys(this.$refs).forEach((key) => {
        if (this.$refs[key].hasOwnProperty('close')) {
          this.$refs[key].close();
        }
      })
    })

    // Reset Data
    $(this.$refs.modal).on('hidden.bs.modal', (e) => Object.assign(this.$data, initialState()));
  },
  computed: {
    checkDocument() {
      return this.document.document_id || this.document.file;
    },
    checkAll() {
      return  (this.users.length > 0) &&
        (this.users.filter(user => user.user_id || this.regEmail.test(user.email || '')).length === this.users.length) &&
        (this.document.document_id || (this.document.file && this.document.name));
    },
    prepepareData() {
      // Add Document Data
      Object.keys(this.document).forEach((key) => {
        if (this.document[key]) {
          this.formData.append(key, this.document[key]);
        }
      })

      // Add User Data
      this.users.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          if (item[key]) {
            this.formData.append(`requests[${index}][${key}]`, item[key]);
          }
        })
      })

      return this.formData;
    }
  },
  methods: {
    /**
     * Select Document Click
     */
    onSelectDocument(document) {
      this.document.document_id = document.id;
      this.document.name = document.name;
      this.$refs.documentBrowser.close();
    },

    /**
     * Select User Click
     */
    onSelectUser(user) {
      this.users.push({
        email: user.email || null,
        user_id: user.id || null,
      });

      this.$refs.userBrowser.close();
    },

    /**
     * Remove User in List
     */
    removeUser(user, index) {
      this.users.splice(index, 1);
    },

    /**
     * Show Editor
     *
     * @param docId Document
     * @param docName
     */
    open(docId, docName) {
      if (docId && docName) {
        this.document.document_id = docId;
        this.document.name = docName;
      }

      $(this.$refs.modal).modal('show')
    },

    /**
     * Send Form
     */
    submitForm() {
      if (! this.checkAll) {
        return;
      }

      $.ajax({
        url: this.apiCreate,
        data: this.prepepareData,
        type: 'POST',
        dataType: 'json',
        contentType: false,
        processData: false,
        mimeType: 'multipart/form-data',
        beforeSend: () => {
          this.progress = true;
        },
        success: () => {
          $(this.$refs.modal).modal('hide');
          Lagina.notifySuccess(this.trans('İmza talebi oluşturuldu'));
        },
        error: (response) => {
          // Show General Error
          Lagina.notifyError(response.responseJSON.message);

          // Show Form Error
          let errors = response.responseJSON.errors;
          Object.keys(errors).forEach(function (key) {
            errors[key].forEach((error) => {
              Lagina.notifyError(error);
            })
          });
        },
        complete: () => {
          this.progress = false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-header {
  background: var(--sidebar-selected);
  color: #FFF;
}

.close-absolute {
  position: absolute;
  right: 25px;
  top: 50%;
  color: #e30202;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: .5;
  transition: .2s all;
  transform: translateY(-50%);
  &:hover {
    opacity: 1;
    color: #ba0101;
  }
}
</style>
